import React, { useEffect } from "react";
import PatientDetail from "./patientForm/PatientDetail";
import PatientSidebar from "./patientForm/PatientSidebar";
import usePatientFormEditing from "./patientForm/usePatientFormEditing";
import usePatientFormShortcuts from "./patientForm/usePatientFormShortcuts";
import usePatientValidation from "./patientForm/usePatientValidation";
import useProduitValidations from "./patientForm/useProduitValidations";

// Éditeur des patients d'une commande : liste à gauche, fiche du patient
// sélectionné à droite. Utilisé par la création de commande, l'ordonnance,
// la validation pharmaceutique et les écrans de production.
export default function PatientForm({
    patients,
    onChange,
    medicamentStrategy,
    commande,
    ehpadId,
    onSave,
    isDirty,
    onValidatePatient,
    productSelectionMode,
    selectedProductIds,
    onToggleProductSelection,
    productValidationAction,
    patientValidationField = "pharmaceuticalValidated",
    patientValidationLabel = "Valider patient",
    canValidatePatient = () => true,
    onSelectedPatientChange,
}) {
    const editing = usePatientFormEditing({ patients, onChange, onSave, isDirty, medicamentStrategy });
    const { selectedIdx, setSelectedIdx } = editing;
    const validations = useProduitValidations(editing.updateSelected);
    const patientValidation = usePatientValidation({ onValidatePatient, patients, selectedIdx });
    usePatientFormShortcuts({
        addPatient: editing.addPatient,
        addDrugToSelected: editing.addDrugToSelected,
        onSave,
        isDirty,
        patientCount: patients.length,
        setSelectedIdx,
    });

    const selectedPatient = patients[selectedIdx] ?? null;
    useEffect(() => {
        onSelectedPatientChange?.(selectedPatient, selectedIdx);
    }, [onSelectedPatientChange, selectedIdx, selectedPatient]);
    const listProps = {
        strategy: medicamentStrategy,
        commande,
        onSave,
        isDirty,
        productSelectionMode,
        selectedProductIds,
        onToggleProductSelection,
        productValidationAction,
    };

    return (
        <div className="commande-editor" style={{ display: "flex", height: "100%", overflow: "hidden" }}>
            <PatientSidebar
                patients={patients}
                selectedIdx={selectedIdx}
                onSelect={setSelectedIdx}
                onAdd={editing.addPatient}
                validationField={patientValidationField}
            />

            <div className="commande-editor-main" style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                {patients.length === 0 ? (
                    <div style={{ padding: "48px", textAlign: "center", color: "#94a3b8", fontSize: "14px" }}>
                        Aucun patient — cliquez sur « Ajouter un patient »
                    </div>
                ) : selectedPatient ? (
                    <PatientDetail
                        patient={selectedPatient}
                        editing={editing}
                        validations={validations}
                        patientValidation={patientValidation}
                        ehpadId={ehpadId ?? commande?.ehpad?.id ?? commande?.ehpadId}
                        listProps={listProps}
                        onValidatePatient={onValidatePatient}
                        patientValidationField={patientValidationField}
                        patientValidationLabel={patientValidationLabel}
                        canValidatePatient={canValidatePatient}
                    />
                ) : null}
            </div>
        </div>
    );
}
